import { PayrollController } from '../../controllers';
import { employeeStore, payrollStore, userStore } from '../../stores';
import React, { useEffect, useState } from 'react';
import { MimaToastUtil } from '../../components';
import constant from '../../utils/constant';
import { Payroll } from '../../pages';
import { observer } from 'mobx-react';

const { getConfiguredPayroll, getPayrollList } = PayrollController;

const PayrollContainer = () => {
	const [viewEmployees, setViewEmployees] = useState(false);
	const [generatePayroll, setGeneratePayroll] = useState(false);
	const [viewPayroll, setViewPayroll] = useState(false);
	const [viewPayrollSummary, setViewPayrollSummary] = useState(false);
	const [createPayroll, setCreatePayroll] = useState(false);
	const [actionPayroll, setActionPayroll] = useState(false);
	const [bulkAddFunds, setBulkAddFunds] = useState(false);
	const [bulkDeductFunds, setBulkDeductFunds] = useState(false);
	const [employeePayBreakdown, setEmployeePayBreakdown] = useState(false);
	const [loading, setLoading] = useState(false);
	const [review, setReview] = useState(false);
	const [askApproval, setAskApproval] = useState(false);
	const [saleSheet, setSaleSheet] = useState(false);
	const [viewMore, setViewMore] = useState(false);
	const [filterBox, setFilterBox] = useState(false);
	const [status, setStatus] = useState('');
	const [dept, setDept] = useState({});
	const [requester, setRequester] = useState('');
	const [action, setAction] = useState('');
	const [tag, setTag] = useState(payrollStore.tags?.[0]?.value || '');
	useEffect(() => {
		const runQuery = async () => {
			setLoading(true);
			localStorage.setItem('tagValue', tag);
			let query = `status=${status}&department=${dept?._id || ''}&tag=${tag}`;
			await Promise.all([
				// getPayrollsGroupByMonth(),
				getPayrollList(query),
				getConfiguredPayroll(),
			]);
			setLoading(false);
		};
		runQuery();
	}, [status, tag, dept?._id]);

	const onStatusClick = stat => {
		if (stat === status) {
			setStatus('');
		} else {
			setStatus(stat);
		}
	};
	const onDeptClick = deptValue => {
		if (deptValue._id === dept._id) {
			setDept({});
		} else {
			setDept(deptValue);
		}
	};
	const onTagClick = tagValue => {
		if (tagValue === tag) {
			setTag(payrollStore.tags?.[0]?.value || '');
		} else {
			setTag(tagValue);
			localStorage.setItem('tagValue', tagValue);
		}
	};
	const resetFilter = () => {
		setDept('');
		setStatus('');
	};

	const showFilter = () => {
		setFilterBox(!filterBox);
	};

	const goToViewMore = () => {
		setViewMore(!viewMore);
	};
	const goToSalesSheet = () => {
		setSaleSheet(!saleSheet);
	};

	const goToPayrollSummary = () => {
		// isOnboardingDone();
		payrollStore.setPayrollSummaries([]);
		setViewPayrollSummary(true);
	};
	const goToCreatePayroll = () => {
		setCreatePayroll(true);
	};
	const goToActionPayroll = () => {
		// isOnboardingDone();
		setActionPayroll(true);
	};

	const goToEmployeePayBreakdown = () => {
		setEmployeePayBreakdown(true);
	};

	const goToReviewPayroll = async (actioner, act) => {
		await getSummary();
		setAction(act);
		setReview(true);
		setRequester(actioner);
	};

	const goToBulkAddFunds = ids => {
		if (ids.length === 0) {
			return MimaToastUtil.error({
				message: 'Select a pending payroll to proceed',
			});
		}
		localStorage.setItem('Seleted IDs', JSON.stringify(ids));
		setBulkAddFunds(true);
	};

	const goToBulkDeductFunds = ids => {
		if (ids.length === 0) {
			return MimaToastUtil.error({
				message: 'Select a pending payroll to proceed',
			});
		}
		localStorage.setItem('Seleted IDs', JSON.stringify(ids));
		setBulkDeductFunds(true);
	};

	const removeIdFromArray = (ids, id) => {
		for (var i = 0; i < ids.length; i++) {
			if (ids[i] === id) {
				ids.splice(i, 1);
			}
		}
		return ids;
	};
	const addIdFromArray = (ids, id) => {
		ids.push(id);
		return ids;
	};

	const closeModal = () => {
		setViewEmployees(false);
		setGeneratePayroll(false);
		setViewPayroll(false);
		setViewPayrollSummary(false);
		setActionPayroll(false);
		setEmployeePayBreakdown(false);
		setBulkAddFunds(false);
		setBulkDeductFunds(false);
		setReview(false);
		setSaleSheet(false);
		setAskApproval(false);
		setCreatePayroll(false);
		employeeStore.setTrackCreateEmployee({});
		employeeStore.setSelectedEmployee({});
		localStorage.setItem('Seleted IDs', JSON.stringify([]));
		localStorage.setItem(constant.RouteParams, JSON.stringify({}));
	};

	const employeeNav = [
		{
			title: 'Create/Refresh Payroll',
			clickAction: goToCreatePayroll,
		},
		{
			title: 'Payroll Summaries',
			clickAction: goToPayrollSummary,
		},
	];
	const { user } = userStore;
	const userPermissions = user.permissions;
	const name = new Set(userPermissions.map(perm => perm.name));
	const { payrolls } = payrollStore || {};

	if (name.has('CAN UPDATE PAYROLL')) {
		employeeNav.push({
			title: 'Add Funds in Bulk',
		});
		employeeNav.push({
			title: 'Deduct Funds in Bulk',
		});
	}
	const refresh = async () => {
		setLoading(true);
		const { status, data, errorMessage } = await PayrollController.refresh();
		if (status !== constant.Success) {
			MimaToastUtil.error({
				message: errorMessage,
			});
		} else {
			MimaToastUtil.success({
				message: data.msg,
			});
		}
		setLoading(false);
	};
	if (name.has('CAN REQUEST PAYROLL REVIEW')) {
		// employeeNav.push({
		// 	title: 'Upload Sales Sheet',
		// 	clickAction: () => goToSalesSheet(),
		// });
		employeeNav.push({
			title: 'Ignore',
		});
		employeeNav.push({
			title: 'Unignore',
		});
		employeeNav.push({
			title: 'Request Review',
			clickAction: () =>
				goToReviewPayroll(constant.MakerCheckerUserType.REQUESTER),
		});
	}
	if (name.has('CAN REVIEW PAYROLL')) {
		employeeNav.push({
			title: 'Request Approval',
			clickAction: () =>
				goToReviewPayroll(constant.MakerCheckerUserType.REVIEWER),
		});
	}
	if (name.has('CAN APPROVE PAYROLL')) {
		employeeNav.push({
			title: 'Approve Payroll',
			clickAction: () =>
				goToReviewPayroll(constant.MakerCheckerUserType.APPROVER),
		});
	}
	if (name.has('CAN VOID PAYROLL')) {
		employeeNav.push({
			title: 'Void Payroll',
			clickAction: () =>
				goToReviewPayroll(
					constant.MakerCheckerUserType.REQUESTER,
					constant.STATUS.VOID
				),
		});
	}
	if (payrolls?.length > 0) {
		employeeNav.push({
			title: 'Download Report',
		});
	}

	// const isOnboardingDone = () => {
	// 	if (userStore.isOnBoardingDone === 'false') {
	// 		MimaToastUtil.error({
	// 			message: constant.OnboardingRequired,
	// 		});
	// 		localStorage.setItem(constant.RoutePath, constant.Routes.Employees);
	// 		return navigate(constant.Routes.OnboardingStageOne);
	// 	}
	// };

	const getSummary = async () => {
		setLoading(true);
		const { errorMessage } = await PayrollController.payrollSummaries(
			`tag=${localStorage.getItem('tagValue')}&type=UNAPPROVED`
		);
		setLoading(false);
		if (errorMessage) {
			payrollStore.setPayrollSummaries([]);
			return MimaToastUtil.error({
				message: errorMessage,
			});
		}
	};
	const onSubmit = async payload => {
		if (payload.ids.length === 0) {
			return MimaToastUtil.error({
				message: 'Select a payroll to proceed',
			});
		}
		localStorage.setItem(constant.RouteParams, JSON.stringify(payload));
		payload.ids = [];
		return goToActionPayroll();
	};
	return (
		<div>
			<Payroll
				viewEmployees={viewEmployees}
				generatePayroll={generatePayroll}
				payrollList={payrollStore.payrolls}
				viewPayroll={viewPayroll}
				saleSheet={saleSheet}
				refresh={refresh}
				statuses={[
					constant.STATUS.PENDING,
					constant.STATUS.REQUEST_CHANGE,
					constant.STATUS.APPROVED,
					constant.STATUS.IN_REVIEW,
					constant.STATUS.REVIEWED,
					constant.STATUS.PARTIALLY_REVIEWED,
					constant.STATUS.IGNORE,
					constant.STATUS.PAID,
					constant.STATUS.VOID,
					constant.STATUS.FAILED,
					constant.STATUS.PROCESSING,
					constant.STATUS.REVERSED,
				]}
				tags={payrollStore.tags}
				loading={loading}
				requester={requester}
				goToSalesSheet={goToSalesSheet}
				goToBulkAddFunds={goToBulkAddFunds}
				goToBulkDeductFunds={goToBulkDeductFunds}
				removeIdFromArray={removeIdFromArray}
				addIdFromArray={addIdFromArray}
				onSubmit={onSubmit}
				status={status}
				action={action}
				dept={dept}
				tag={tag}
				setFilterBox={setFilterBox}
				viewPayrollSummary={viewPayrollSummary}
				createPayroll={createPayroll}
				actionPayroll={actionPayroll}
				closeModal={closeModal}
				onTagClick={onTagClick}
				onStatusClick={onStatusClick}
				onDeptClick={onDeptClick}
				employeeNav={employeeNav}
				employeePayBreakdown={employeePayBreakdown}
				goToEmployeePayBreakdown={goToEmployeePayBreakdown}
				bulkAddFunds={bulkAddFunds}
				bulkDeductFunds={bulkDeductFunds}
				askApproval={askApproval}
				review={review}
				viewMore={viewMore}
				departments={employeeStore.departments}
				filterBox={filterBox}
				showFilter={showFilter}
				resetFilter={resetFilter}
				goToViewMore={goToViewMore}
				setViewMore={setViewMore}
			/>
		</div>
	);
};

export default observer(PayrollContainer);
